import { Link } from "react-router-dom";

import { ReactComponent as  PhoneIcon} from "../../../../assets/images/icons/phone.svg";
import { ReactComponent as  SearchIcon}from "../../../../assets/images/icons/search.svg";
import { ReactComponent as  AboutIcon} from "../../../../assets/images/icons/about.svg";



export const HeaderNav = ({props}) => {
    return (
        <>
            <div className="nav-items position-absolute position-absolute top-0 end-0 mt-1 me-1 d-flex justify-content-end align-items-center">
                <Link to={`/search`} className="search-open me-2">
                    <SearchIcon/>
                </Link>
                
                <div className="me-2">
                    <a href={`tel:${props?.[2]?.value}`}>
                        <PhoneIcon/>
                    </a>
                </div>
                <div className="about-item d-flex justify-content-center align-items-center " data-bs-toggle="modal" data-bs-target="#location-modal">
                        <AboutIcon/>
                        <span>Про нас</span>
                </div>
            </div>
        </>
        
    )
}